import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import DocumentPanel from '../../common/document/DocumentPanel';
import MultipleImagePanel from '../../common/image/MultipleImagePanel';
import EventDetail from './EventDetail';
import EventItem from './EventItem';
import EventManager from './EventManager';
import styles from "../../../../components/Display/Wrapper.module.scss";

function EventPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagesManagerIsOpen, setImagesManagerIsOpen] = useState(false);
  const [documentManagerIsOpen, setDocumentManagerIsOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(undefined);
  const [layout, setLayout] = useState('grid');

  const fetchEventList = async () => {
    await privateFetch('GET', 'kerbouzier', `/cu/${accountContext.id}/event/`).then((res) => {
      setEventList(res);
    });
  };

  useEffect(() => {
    fetchEventList();
  }, [navigationContext]);

  const fetchEventDetail = async () => {
    await privateFetch(
      'GET',
      'kerbouzier',
      `/cu/${accountContext.id}/event/${navigationContext.activeEventId}/`
    ).then((res) => {
      if (res) setEventDetail(res);
    });
  };

  const handleClickEvent = (event) => {
    setActiveView("kbevent", event, "activeEventId");
  };

  useEffect(() => {
    if (navigationContext.activeEventId) {
      fetchEventDetail();
    } else setEventDetail(undefined);
  }, [navigationContext]);

  const goBackEventAction = {
    onClick: handleClickEvent,
    label: 'Retour à la liste'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newEventAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un évènement',
    icon: 'pi-plus'
  };

  const createEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'kerbouzier',
      `/cu/${accountContext.id}/event/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setLoading(false);
      setEventDetail(undefined);
    });
  };

  const updateEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'kerbouzier',
      `/cu/${accountContext.id}/event/${eventDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteEvent = async (event) => {
    await privateFetch(
      'DELETE',
      'kerbouzier',
      `/cu/${accountContext.id}/event/${event.id}/`,
      "L'évènement a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };

  const updateEventImages = async (images) => {
    await privateFetch(
      'PUT',
      'kerbouzier',
      `/cu/${accountContext.id}/event/${eventDetail.id}/images/`,
      "Les images de l'évènement ont bien été modifiées",
      JSON.stringify({
        images: images.map((image) => image.id)
      })
    ).then(() => {
      fetchEventDetail();
      // setImagesManagerIsOpen(false);
      setLoading(false);
    });
  };

  const uploadSectionDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'kerbouzier',
      `/cu/${accountContext.id}/event/${eventDetail.id}/file/`,
      'Le fichier a bien été enregistré',
      documentForm,
      false,
      true
    ).then(() => {
      fetchEventDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const updateDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/file/${selectedDocument.id}/`,
      'Le document a bien été modifié',
      documentForm,
      false,
      true
    ).then(() => {
      fetchEventDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const handleCreateDocument = () => {
    setSelectedDocument(undefined);
    setDocumentManagerIsOpen(true);
  };

  const handleUpdateDocument = (document) => {
    setSelectedDocument(document);
    setDocumentManagerIsOpen(true);
  };

  const handleDeleteDocument = async (document) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/file/${document.id}/`,
      'Le document a bien été supprimé'
    ).then(() => {
      fetchEventDetail(eventDetail.id);
      fetchEventList();
      setSelectedDocument(undefined);
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };


  const itemTemplate = (event) => (
    <EventItem event={event} handleClickEvent={() => handleClickEvent(event)} />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Agenda"
        labelAction={handleClickEvent}
        actions={eventDetail ? [goBackEventAction] : [changeLayoutAction, newEventAction]}
        detail={eventDetail}>
        {!eventDetail ? (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {eventList.map((event, index) => (
                <EventItem
                  layout={layout}
                  key={index}
                  event={event}
                  handleClickEvent={() => handleClickEvent(event)} />
              ))}
            </div>
          </div>) : (
          <EventDetail
            event={eventDetail}
            handleUpdateEvent={handleOpenManager}
            handleDelete={deleteEvent}
            handleUpdateImages={() => setImagesManagerIsOpen(true)}
            handleCreateFile={handleCreateDocument}
            handleDeleteFile={handleDeleteDocument}
            handleUpdateFile={handleUpdateDocument}
            loading={loading}
          />
        )}
      </PageWrapper>

      <MultipleImagePanel
        loading={loading}
        isOpen={imagesManagerIsOpen}
        onClose={() => {
          setImagesManagerIsOpen(false);
        }}
        images={eventDetail?.images}
        onValidate={updateEventImages}
      />

      <EventManager
        isOpen={panelIsOpen}
        onClose={setPanelIsOpen}
        event={eventDetail}
        onCreate={createEvent}
        onUpdate={updateEvent}
        loading={loading}
      />

      <DocumentPanel
        document={selectedDocument}
        loading={loading}
        isOpen={documentManagerIsOpen}
        onClose={() => {
          setSelectedDocument(null);
          setDocumentManagerIsOpen(false);
        }}
        onCreate={uploadSectionDocument}
        onUpdate={updateDocument}
      />
    </div>
  );
}

export default EventPage;
